import React from 'react'
import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'
import PlacingOrder from './PlacingOrder'
import PlaceOrderContainer from '@/checkout-instore-legacy/order/containers/PlaceOrderContainer'

const PlacingOrderContainer = () =>
  getInstoreConfig().challengeDrivenPaymentWorkflow ? (
    <PlacingOrder />
  ) : (
    <PlaceOrderContainer />
  )

export default PlacingOrderContainer
